/**
 * GA4 Event Names
 * Based on Google Analytics 4 ecommerce spec
 */

// Ecommerce Tracking Events
export const ECOM_EVENTS = {
  VIEW_ITEM_LIST: 'view_item_list',
  SELECT_ITEM: 'select_item',
  VIEW_ITEM: 'view_item',
  ADD_TO_CART: 'add_to_cart',
  REMOVE_FROM_CART: 'remove_from_cart',
  VIEW_CART: 'view_cart',
  BEGIN_CHECKOUT: 'begin_checkout',
  PURCHASE: 'purchase',
  VIEW_PROMOTION: 'view_promotion',
  SELECT_PROMOTION: 'select_promotion'
};

// General Tracking Events
export const GENERAL_EVENTS = {
  SEARCH: 'search',
  SEARCH_RESULT_CLICK: 'search_result_click',
  PAGE_VIEW: 'page_view',
  POPULAR_CATEGORY_CLICK: 'popular_category_click'
};

// All events combined
export const EVENTS = {
  ...ECOM_EVENTS,
  ...GENERAL_EVENTS
};

// Page types
export const PAGE_TYPES = {
  HOME: 'Homepage',
  CATEGORY: 'PLP',
  PRODUCT: 'PDP',
  CHECKOUT: 'Checkout',
  SEARCH: 'Search',
  CONTENT: 'Other',
  OTHER: 'Other',
  HOOKS_ACADEMY: 'Hooks Academy',
  ACTIVITY: 'Activity',
  STORES: 'Stores',
  MY_PAGES: 'My Pages'
};

// Default currency
export const DEFAULT_CURRENCY = 'SEK';

// Debug mode - set to true to log all tracking events
export const DEBUG_TRACKING = process.env.NODE_ENV === 'development';

